import { InjectionToken } from '@angular/core';

export const IS_PRODUCTION = new InjectionToken<boolean>(
  '[Meta] is in production environment',
);
